import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";

import Select from "react-select";
import FilePreview from "components/Common/previewFile";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCardPartenaire";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentPmeHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestisseursHm from "components/Common/InvestisseursHm(mesCgps)";
import DeleteButton from "components/Common/DeleteButtonShow";

import Config from "config";
import ContactHm from "components/Common/ContactHm";
const cgpDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modal_1, setModal_1] = useState(false);

  const toggleModal = () => setModal(!modal);
  const [cgpData, setCgpData] = useState([]);

  const [investisseurs, setInvestisseurs] = useState([]);
  const [contacts, setContacts] = useState([]);

  const [documentData, setDocumentData] = useState([]);
  // edit hm document
  const [docData, setDocData] = useState();
  const [docId, setDocId] = useState("");
  const [selectedCategories, setSelectedCategorie] = useState();
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  const [selectedPme, setSelectedPme] = useState();
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };

  const [selectedType, setSelectedType] = useState();
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const [selectedNom, setSelectedNom] = useState();
  const [selectedFichier, setSelectedFichier] = useState();

  const handleFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [selectedComment, setSelectedComment] = useState("");
  // New
  const [newCategories, setNewCategorie] = useState("");
  const [newType, setNewType] = useState("");
  const [newNom, setNewNom] = useState("");
  const [newFichier, setNewFichier] = useState("");
  const [newComment, setNewComment] = useState("");

  const handleNewCategorieChange = (e) => {
    setNewCategorie(e);
  };

  const handleNewTypeChange = (e) => {
    setNewType(e);
  };

  const handleNomChange = (e) => {
    setNewNom(e.target.value);
  };

  const handleNewFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setNewFichier(newFile);
    } else {
      setNewFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Comptable | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={{ ...(type_compte == "client" ? navStyleClient : navStyle) }}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {type_compte == "client" && !loading ? (
              "Détails " + cgpData.sil
            ) : !loading ? (
              "Détails"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
        {cgpData?.hm_accessibles?.map((key, index) =>
          key === "hm_investisseurs" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "investisseurs" ? "active" : ""
                }`}
                onClick={() => handleTabClick("investisseurs")}
              >
                {!loading ? (
                  investisseurs?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents")}
              >
                {!loading ? (
                  documentData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_contacts" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "contacts" ? "active" : ""
                }`}
                onClick={() => handleTabClick("contacts")}
              >
                {!loading ? (
                  contacts?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };
  const getDocumentDetail = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/partenaires_documents/${docId}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDocData(data);
          setSelectedCategorie(
            data?.detail_partenaires_document["Identification du documents"][
              "Catégorie"
            ]
          );
          setSelectedPme(
            data?.detail_partenaires_document["Identification du documents"][
              "Partenaire"
            ]
          );
          setSelectedType(
            data?.detail_partenaires_document["Identification du documents"][
              "Type"
            ]
          );
          setSelectedNom(
            data?.detail_partenaires_document["Identification du documents"][
              "Nom"
            ]
          );
          setSelectedFichier(
            data?.detail_partenaires_document["Identification du documents"][
              "Fichier"
            ]
          );
          setSelectedComment(
            data?.detail_partenaires_document["Identification du documents"]
              .Commentaires
          );
          setModal(true);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [typeDocData, setTypeDocData] = useState({ data: [] });
  const renderTypeDocOptions = () => {
    return [
      {
        options: typeDocData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getTypeDoc = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/partenaires_documents/types_documents?id=${docId}&categories_document_id=${
          selectedCategories?.value || newCategories?.value
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTypeDocData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [categorieData, setCategorieData] = useState({ data: [] });
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getCategorieDocument = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/partenaires_documents/categories_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setCategorieData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleNewSubmit = async () => {
    if (newCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (newType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (newFichier == null || "") {
      toast.error("Merci de renseigner un fichier");
    } else {
      document.getElementById("create_button").disabled = true;
      const formData = new FormData();
      formData.append("partenaire_id", id);
      formData.append("fichier", newFichier);
      formData.append("categories_document_id", newCategories?.value);
      formData.append("types_document_id", newType?.value);
      formData.append("nom", newNom);
      formData.append("commentaires", newComment);
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_documents/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Ajouté");
          setModal_1(false);
          getDocumentHm();
        } else {
          document.getElementById("create_button").disabled = false;
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (responseData && responseData.partenaires_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.partenaires_document_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };

  const handleUpdateSubmit = async () => {
    if (selectedCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (selectedType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("id", docId);
        formData.append("partenaire_id", id);
        formData.append("fichier", selectedFichier);
        formData.append("categories_document_id", selectedCategories?.value);
        formData.append("types_document_id", selectedType?.value);
        formData.append("nom", selectedNom);
        formData.append("commentaires", selectedComment);
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_documents/${docId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Modifié");
          getDocumentHm();
          setLoading(false);
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          setLoading(false);
          if (responseData && responseData.partenaires_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.partenaires_document_validation[0];
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const getDocumentHm = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/partenaires_industriels/${id}/hm_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDocumentData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTypeDoc();
    getCategorieDocument();
  }, [selectedCategories, newCategories]);
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_industriels/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const cgpData = await response.json();
        setCgpData(cgpData);
        {
          cgpData?.hm_accessibles?.map(async (key, index) =>
            key === "hm_investisseurs"
              ? await getInvestisseurs()
              : key === "hm_documents"
              ? await getDocumentHm()
              : key === "hm_contacts"
              ? await getContacts()
              : null
          );
        }
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };
    const getInvestisseurs = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/partenaires_industriels/${id}/hm_investisseurs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setInvestisseurs(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getContacts = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/partenaires_cgps/${id}/hm_contacts`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setContacts(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getDocumentHm = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/partenaires_industriels/${id}/hm_documents`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setDocumentData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const handleGoBack = () => {
    window.history.back(); // Cela vous ramènera en arrière dans l'historique du navigateur
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  const ids = {
    partenaire_id: id,
    societe_id: cgpData?.detail_partenaire?.ids.societe_id,
  };
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/partenaires_industriels`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Comptable
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        cgpData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {cgpData.can_edit ? (
                        <Link
                          to={`${backUrl}/partenaires_industriels/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {cgpData.can_destroy ? (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/partenaires_industriels/${id}`}
                        />
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {cgpData?.detail_partenaire?.Identification ? (
                                <IdentificationCard
                                  title="Identification"
                                  details={
                                    cgpData?.detail_partenaire?.Identification
                                  }
                                  ids={cgpData?.detail_partenaire?.ids}
                                />
                              ) : null}
                            </Col>

                            <Col sm="6">
                              <Row>
                                {cgpData?.detail_partenaire?.[
                                  "Données complémentaires CGP"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Données complémentaires CGP"
                                    details={
                                      cgpData?.detail_partenaire?.[
                                        "Données complémentaires CGP"
                                      ]
                                    }
                                  />
                                ) : null}

                                {cgpData?.detail_partenaire?.[
                                  "Données complémentaires Direction produit"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Données complémentaires Direction produit"
                                    details={
                                      cgpData?.detail_partenaire?.[
                                        "Données complémentaires Direction produit"
                                      ]
                                    }
                                  />
                                ) : null}
                              </Row>
                            </Col>

                            {cgpData?.detail_partenaire?.Audit ? (
                              <SectionCard
                                title="Audit"
                                details={cgpData?.detail_partenaire?.Audit}
                              />
                            ) : null}
                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          {documentData?.can_add ? (
                            <div style={{ textAlign: "left" }}>
                              <Link
                                id={`edittooltip-}`}
                                className="btn btn-sm btn-primary"
                                onClick={() => setModal_1(true)}
                              >
                                <i className="bx bx-plus"></i>Ajouter
                              </Link>
                            </div>
                          ) : null}
                          <DocumentHm
                            title={documentData}
                            data={documentData?.data}
                            header={documentData?.header}
                            itemsPerPage={10}
                            onClick={(documentId) => {
                              getDocumentDetail(documentId);
                              getTypeDoc(documentId);
                              setDocId(documentId);
                            }}
                            controller="partenaires_documents"
                          />
                          <Modal isOpen={modal} toggle={() => setModal(!modal)}>
                            <ModalHeader
                              toggle={() => setModal(!modal)}
                              tag="h4"
                            >
                              Détails du document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  setModal(false);
                                  handleUpdateSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Partenaire
                                      </Label>
                                      <Input
                                        name="partenaire"
                                        type="text"
                                        placeholder="Partenaire"
                                        value={selectedPme}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={selectedCategories}
                                        onChange={handleCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={selectedType}
                                        onChange={handleTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={selectedNom}
                                        onChange={(e) =>
                                          setSelectedNom(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={selectedComment}
                                        onChange={(e) =>
                                          setSelectedComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier :
                                      </Label>
                                      <FilePreview
                                        fileUrl={
                                          docData?.detail_partenaires_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                      />
                                      <a
                                        href={
                                          docData?.detail_partenaires_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Télécharger le fichier
                                      </a>
                                      <input
                                        type="file"
                                        onChange={handleFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        className="btn btn-success save-user"
                                      >
                                        Enregistrer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={modal_1}
                            toggle={() => setModal_1(!modal_1)}
                          >
                            <ModalHeader
                              toggle={() => setModal_1(!modal_1)}
                              tag="h4"
                            >
                              Nouveau document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleNewSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Partenaire
                                      </Label>
                                      <Input
                                        name="parteanire"
                                        type="text"
                                        placeholder="parteanire"
                                        value={cgpData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={newCategories}
                                        onChange={handleNewCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={newType}
                                        onChange={handleNewTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#555B21"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "white"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={newNom}
                                        onChange={handleNomChange}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={newComment}
                                        onChange={(e) =>
                                          setNewComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier
                                      </Label>

                                      <input
                                        type="file"
                                        onChange={handleNewFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Créer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}

                  {activeTab === "investisseurs" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <InvestisseursHm
                            title={investisseurs}
                            data={investisseurs?.data}
                            header={investisseurs?.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "contacts" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <ContactHm
                            title={contacts}
                            data={contacts?.data}
                            header={contacts?.header}
                            itemsPerPage={10}
                            ids={ids}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default cgpDetail;
